import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class CommonApi {
  getAllMetaData(config) {
    return axios.get(BASE_URL + "/cms/common/getAllMetaData", config)
  }

  getNotificationByUserId(config) {
    return axios.get(BASE_URL + "/cms/common/notifications", config)
  }

  getCountryEducationStats(country,config) {
    return axios.get(`${BASE_URL}/cms/common/getCountryEducationStats/${country}`, config)
  }

 
}

export default new CommonApi()
